import { render, staticRenderFns } from "./CalibratePH.vue?vue&type=template&id=312e8215&"
import script from "./CalibratePH.vue?vue&type=script&lang=js&"
export * from "./CalibratePH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports